import React, { useState, useEffect } from 'react';
import SubmitAnswerButton from './submitanswersbutton';

const WritingTest = ({ questionNumber, onNext, isLastQuestion, questionData, candidateTestId, getTotalExamVideoDuration, timeRemaining, getVideoDuration, isLastQuestionOfSection,currentSection,sectionQuestions }) => {
  
  const transformQuestionData = (data) => {
    if (!data) return { topic: 'Writing Task', prompt: 'Write your essay here.', minChars: 50, maxChars: 200, timeLimit: 900 };
    
    
    if (data.prompt) {
      return {
        topic: `Essay ${questionNumber}`,
        prompt: data.prompt,
        minChars: data.minChars || 50,
        maxChars: data.maxChars || 200,
        timeLimit: data.timeLimit || 900
      };
    }
    
    
    return {
      topic: `Essay ${questionNumber}`,
      prompt: data.text || "Write your essay here.",
      minChars: 50,
      maxChars: 200,
      timeLimit: data.timeLimitSeconds || 900
    };
  };
  
  const currentPrompt = transformQuestionData(questionData);
  
  const [text, setText] = useState('');
  const [charCount, setCharCount] = useState(0);
  const [isSubmitted, setIsSubmitted] = useState(false);

  useEffect(() => {
    const chars = text.replace(/\s/g, '').length;
    setCharCount(chars);
  }, [text]);

  const handleTextChange = (e) => {
    if (!isSubmitted) {
      const newText = e.target.value;
      if (newText.replace(/\s/g, '').length <= currentPrompt.maxChars) {
        setText(newText);
      }
    }
  };

  const blockClipboardAction = (e) => {
    e.preventDefault();
  };

  const handleKeyDown = (e) => {
    if ((e.ctrlKey || e.metaKey) && ['v', 'c', 'x'].includes(e.key.toLowerCase())) {
      e.preventDefault();
    }
  };

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  return (
    <div className="test-type-container writing-test">
      <div className="writing-header">
        <div className="step-question">
          <h3 className="question-title">{currentPrompt.topic}</h3>
          <p className="writing-prompt">{currentPrompt.prompt}</p>
          <p className="writing-requirements"><strong>Requirements:</strong> Minimum {currentPrompt.minChars} characters (Maximum: {currentPrompt.maxChars} characters)
          </p>
        </div>

        <div className="writing-stats">
          <div className="stat-item">
            <span className="stat-label">Time Left:</span>
            <span className={`stat-value ${timeRemaining < 120 ? 'warning' : ''}`}>
              {formatTime(timeRemaining)}
            </span>
          </div>
          <div className="stat-item">
            <span className="stat-label">Character Count:</span>
            <span className={`stat-value ${
              charCount >= currentPrompt.minChars && charCount <= currentPrompt.maxChars 
                ? 'success' 
                : charCount > currentPrompt.maxChars 
                  ? 'warning' 
                  : ''
            }`}>
              {charCount} / {currentPrompt.maxChars}  
            </span>
          </div>
        </div>
      </div>

      <div className="writing-area">
        <textarea
          className="writing-textarea"
          placeholder="Start writing your response here..."
          value={text}
          onChange={handleTextChange}
          onPaste={blockClipboardAction}
          onCopy={blockClipboardAction}
          onCut={blockClipboardAction}
          onKeyDown={handleKeyDown}
          disabled={isSubmitted}
          rows="15"
        />
      </div>

      <div className="action-buttons">
        
          <SubmitAnswerButton
            questionNumber={questionNumber}
            questionData={questionData}
            candidateTestId={candidateTestId}
            isLastQuestion={isLastQuestion}
            isLastQuestionOfSection={isLastQuestionOfSection} 
            onNext={onNext}
            textAnswer={text}
            testType="text"
            hasRecorded={true}
            timeRemaining={timeRemaining}
            disabled={charCount > currentPrompt.maxChars}
            getVideoDuration={getVideoDuration}
            getTotalExamVideoDuration={getTotalExamVideoDuration}
            section={currentSection}
            sectionQuestions={sectionQuestions}
          />
        
      </div>
    </div>
  );
};

export default WritingTest;
